import { render } from "./UserResetPassword.vue?vue&type=template&id=9101e4b2&scoped=true"
import script from "./UserResetPassword.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./UserResetPassword.vue?vue&type=script&charset=utf-8&lang=js"

import "./UserResetPassword.vue?vue&type=style&index=0&id=9101e4b2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9101e4b2"]])

export default __exports__